import { createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-235c46b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form__container" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["type", "name", "id", "placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", { for: _ctx.input }, null, 8, _hoisted_2),
    _withDirectives(_createElementVNode("input", {
      type: _ctx.input,
      name: _ctx.name,
      id: _ctx.id,
      onFocusin: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.focus && _ctx.focus(...args))),
      onFocusout: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.focusRemove && _ctx.focusRemove(...args))),
      placeholder: _ctx.pholder,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.setModel) = $event))
    }, null, 40, _hoisted_3), [
      [_vModelDynamic, _ctx.setModel]
    ])
  ]))
}